import script from "./SetupTimezoneCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupTimezoneCard.vue?vue&type=script&setup=true&lang=js"

import "./SetupTimezoneCard.vue?vue&type=style&index=0&id=10ccb3b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ccb3b4"]])

export default __exports__